var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"logo-image"},[_c('v-img',{staticClass:"image",attrs:{"src":_vm.images.logo,"alt":"logo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }